/**
 * DB `Json` / unknown → listing attributes record.
 *
 * Leaf module (no runtime imports from other listing specs) so form hydrators
 * and pricing can share one boundary without circular module graphs.
 */

import type { ListingSpecAttributes } from "@/lib/listing/specRequirements";

/**
 * Narrow DB `Json` / unknown attribute blobs to a plain object record.
 * Arrays and primitives return null (callers treat as empty attrs).
 */
export function asListingAttributesRecord(
  value: unknown,
): Record<string, unknown> | null {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
}

/**
 * Same boundary as {@link asListingAttributesRecord}, typed for listing spec keys.
 * Empty object when value is not a plain object.
 */
export function asListingSpecAttributes(value: unknown): ListingSpecAttributes {
  return (asListingAttributesRecord(value) ?? {}) as ListingSpecAttributes;
}
